/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Upload, Icon, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config, downLoadTemplate, toImportExcel} from 'Utils';
import {getSubStoreList, setProductUp, setProductDown, getProductCategory, del2} from '../../service/product';
import {Store, Actions} from './store';

class ProductCustomerList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            opts: ['子库存管理'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            selectedRow: [],
            rows: [],
            total: 1,
            searchObj: {
                subStoreName: '',
                s: 10,
                p: 1,
            },
            categoryData: [],
            button_limits_end: {},
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    onSelectChange = (selectedRowKeys, selectedRow) => {
        this.setState({selectedRowKeys, selectedRow});
    }

    goView(url) {
        hashHistory.push(url);
    }

    goDelete() {
        const {selectedRow, selectedRowKeys} = this.state;
        const takeEffect = selectedRow.some(item => item.takeEffect === 'N');
        if (takeEffect) {
            openNotice('warning', '不能删除已失效子库存', '');
            return;
        }
        del2(selectedRowKeys).then((result) => {
            if (result && result.code == 200 && result.data) {
                openNotice('success', '删除成功', '');
                this.initData();
                this.setState({
                    selectedRowKeys: [],
                    selectedRow: []
                });
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
            }
        });

    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                subStoreName: ''
            },
            loading: true
        }, function () {
            self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1,
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    updateProductStatusFn(key) {
        /* 产品上下架 */
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        if (key == 'up') {
            setProductUp(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '上架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '上架操作失败', (result && result.message) ? result.message : '');
                }
            });
        } else {
            setProductDown(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '下架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '下架操作失败', (result && result.message) ? result.message : '');
                }
            });
        }
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        getSubStoreList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                this.setState({loading: false});
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    /* 导入之前 */
    /*beforeToImport (res) {
        return new Promise((resolve, reject) => {
            console.log(res);
            let _arr = res.name.split('.')
                , _tar = _arr[_arr.length - 1]
                ;
            console.log(_tar);
            if (_tar != 'xls' && _tar != 'xlsx') {
                message.warning('请上传从模板下载的Excel文件');
                return
            }
            if (res.size > 5242880) {
                message.warning('上传的文件过大，不能超过5M');
                return
            }
            resolve();
        });
    }*/
    /* 导入 */
    /*toImport (res) {
    if (res.file.status !== 'uploading') {
      console.log(res.file, res.fileList);
    }
    if (res.file.status === 'done') {
      if (res.file.response.status) {
        message.success(res.file.response.message, 3);
      } else {
        message.error(res.file.response.message, 3);
      }
    } else if (res.file.status === 'error') {
      message.error('上传文件失败');
    }
    }*/

    /* 下载模板 */
    downTemplate() {
        downLoadTemplate(3);
    }

    edit(record) {
        this.goView(`/subStock/edit/${record.id}`);
    }

    render() {
        const {opts, key, rows, total, searchObj, selectedRow, selectedRowKeys, button_limits_end, loading} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'subStoreName',
                    label: '子库存名称',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.subStoreName
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '子库存编码',
                    dataIndex: 'subStoreNumber',
                    width: '200px',
                }, {
                    title: '子库存名称',
                    dataIndex: 'subStoreName',

                }, {
                    title: '子库存说明',
                    dataIndex: 'sutStoreText',

                }, {
                    title: '主库存',
                    dataIndex: 'masterStore',
                    render: text => text == 'Y' ? <span>是</span> : <span>否</span>
                }, {
                    title: '是否生效',
                    dataIndex: 'takeEffect',
                    render: text => text == 'Y' ? <span>是</span> : <span>否</span>
                }, {
                    title: '失效日期',
                    dataIndex: 'postDue',
                }, {
                    title: '编辑',
                    render: (text, record, index) => <Button icon="edit" onClick={() => {
                        this.edit(record)
                    }}>编辑</Button>
                }
            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                selectedRow,
                onChange: this.onSelectChange,
                showUploadList: false,
            }
        };
        const hasSelected = selectedRowKeys.length > 0;
        let self = this;
        /*let uploadParam = {
      action: `${config.server}/api/v1/common/downExcel/excelImport`,
      beforeUpload: self.beforeToImport.bind(self),
      onChange: self.toImport.bind(self),
      className: 'toImportBtn',
      showUploadList: false,
      data: (file) => {
          console.log(file);
        return {
          uploadFile: file,
          type: 1,
        }
      }
        }*/
        let uploadParam = toImportExcel(3, () => {
            this.initData();
        });
        return <div>
            <DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content"><AdvanceFormNew  {...filterBoxProps}/></div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    {
                        button_limits_end.subStock_list_01
                        &&
                        <Upload {...uploadParam}>
                            <Button style={{position: 'absolute', bottom: 8, right: 0}}>
                                <Icon type="upload"/>导入
                            </Button>
                        </Upload>
                    }
                    {button_limits_end.subStock_list_01 && <Button onClick={this.downTemplate.bind(this)} style={{
                        position: 'absolute',
                        bottom: 8,
                        right: 88
                    }}>下载模板</Button>}
                    {button_limits_end.subStock_list_02 &&
                    <Button icon="plus" onClick={this.goView.bind(this, `/subStock/add`)}
                            style={{position: 'absolute', bottom: 8, left: 0}}>新增</Button>}
                    {/*{button_limits_end.subStock_list_03 && <Button
                        type="primary"
                        onClick={this.goDelete.bind(this)}
                        disabled={!hasSelected}
                        icon="minus"
                    >删除</Button>}*/}
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}
;
export default withRouter(ProductCustomerList);


// WEBPACK FOOTER //
// ./src/routes/subStock/list.js